import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { SKIP_AUTH } from './skip-auth.interceptor-context';

export const KIOSK_REQUEST = new HttpContextToken<boolean>(() => false);

export const kioskAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.context.get(KIOSK_REQUEST)) return next(req);

  const deviceToken = localStorage.getItem('kiosk_device_token')?.trim() ?? '';
  if (!deviceToken) return next(req);

  const cloned = req.clone({
    setHeaders: { 'X-Device-Token': deviceToken },
    context: req.context.set(SKIP_AUTH, true),
  });

  return next(cloned);
};
